import { FileViewLoader } from "components/FileView";
import { useParams, useSearchParams } from "react-router-dom";

export default function FilestorePreview() {
    const { fileId } = useParams();

    const [searchParams] = useSearchParams();

    const document = {
        fileId,
        id: searchParams.get("id") ?? "",
        title: searchParams.get("title") ?? "",
        type: searchParams.get("type") ?? ""
    };

    return <FileViewLoader document={document} fileView="preview" allowZoomPanPinch={true} hideFullScreenButton={true}/>
}